const e = {
  save: "Save",
  edit: "Edit",
  remove: "Remove",
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
  strike: "Strikethrough",
  link: "Link",
  unorderedList: "Bullet list",
  orderedList: "Ordered list",
  clean: "Clean formatting",
  video: "Embed video",
  alignCenter: "Align text to center",
  alignLeft: "Align text to left",
  alignRight: "Align text to right",
  image: "Embed image",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",
  sup: "Super script",
  sub: "Sub script",
  code: "Code",
  codeBlock: "Code block",
  blockquote: "Block quote"
};
export {
  e as DEFAULT_LABELS
};
